(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5769],{

/***/ 59968:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/print/product",
      function () {
        return __webpack_require__(7510);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64384);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55150);
/* harmony import */ var _redux_action_productFiltersAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7330);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  > span {\n    margin-right: 10px;\n  }\n  .btn {\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    padding: 0 20px;\n    border-radius: 10px;\n  }\n\n  @media (max-width: 991px) {\n    justify-content: flex-start;\n  }\n  @media (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  flex-direction: column;\n\n  & span {\n    margin-right: 10px;\n    text-align: end;\n    font-size: 14px;\n  }\n\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  & button {\n    border: none;\n    background: #3bb77e;\n    color: #fff;\n    border-radius: 10px;\n    font-size: 14px;\n    word-break: keep-all;\n    height: 30px;\n    :hover {\n      background-color: #fd7e14;\n    }\n  }\n\n  @media (max-width: 767px) {\n    display: grid;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 120px;\n  height: 30px;\n  text-align: center;\n  padding: 0 10px;\n  margin-right: 10px;\n  @media (max-width: 767px) {\n    font-size: 14px;\n    width: 100%;\n    max-width: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  height: 30px;\n  text-align: center;\n  border: 1px solid #ececec;\n  background-color: #fff;\n  border-radius: 10px;\n  margin-right: 10px;\n  padding: 0px 20px;\n\n  @media (max-width: 767px) {\n    font-size: 14px;\n    width: 100%;\n    max-width: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 15px;\n  font-size: 14px;\n  color: #666;\n\n  @media (max-width: 767px) {\n    margin-bottom: 10px;\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var SizeFilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3d609b4-0"
})(_templateObject());
var MobileSizeFilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3d609b4-1"
})(_templateObject1());
var SizeInput = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-b3d609b4-2"
})(_templateObject2());
var SizeSelect = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-b3d609b4-3"
})(_templateObject3());
// 사이즈 형식을 표시하는 레이블 컴포넌트 추가
var SizeFormatLabel = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3d609b4-4"
})(_templateObject4());
var SizeFilter = function(param1) {
    var _$updateProductFilters = param1.updateProductFilters, productFilters = param1.productFilters, handleSizeFilter = param1.handleSizeFilter, viewHeight = param1.viewHeight, categorySizeSearch = param1.categorySizeSearch, selectedCategory = param1.selectedCategory;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        horizontal: "",
        vertical: "",
        height: "",
        range: ""
    }), selectedSizes = ref[0], setSizes = ref[1];
    // 선택된 카테고리에 따라 필터 타입 결정
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("default"), filterType = ref1[0], setFilterType = ref1[1]; // default, box 등
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // 선택된 카테고리에 따라 필터 타입 설정
        if (selectedCategory) {
            // 여러 카테고리가 선택된 경우 (공백으로 구분)
            var categoryArray = selectedCategory.split(" ");
            // 박스 카테고리 확인 (01, 02, 10 중 하나라도 포함되면 박스 타입)
            var isBoxCategory = categoryArray.some(function(cat) {
                return cat.startsWith("BOX") || cat === "01" || cat === "02" || cat === "10";
            });
            // 비닐봉투 카테고리 확인 (16, 17, 06)
            var isEnvelopeCategory = categoryArray.some(function(cat) {
                return cat === "16" || cat === "17" || cat === "06";
            });
            if (isBoxCategory) {
                // 박스 카테고리가 포함되어 있으면 박스 타입으로 설정
                setFilterType("box");
            } else {
                setFilterType("default");
            }
        }
    }, [
        selectedCategory,
        viewHeight
    ]);
    // 페이지 진입 시 초기 값 설정
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        _$updateProductFilters(_objectSpread({}, productFilters, {
            sizes: {
                horizontal: "",
                vertical: "",
                height: "",
                range: ""
            }
        }));
        if (!router.query.sizes) {
            setSizes({
                horizontal: "",
                vertical: "",
                height: "",
                range: ""
            });
        }
    }, [
        router.query
    ]);
    var handleFilter = function() {
        var hasValue = Object.entries(selectedSizes).filter(function(param) {
            var _param = _slicedToArray(param, 1), key = _param[0];
            return filterType === "box" || key !== "height";
        }) // 박스 타입이 아니면 height는 검사하지 않음
        .some(function(param) {
            var _param = _slicedToArray(param, 2), value = _param[1];
            return value > 0;
        });
        if (!hasValue) {
            return (0,_common_alert__WEBPACK_IMPORTED_MODULE_4__/* .failAlert */ .qh)("1\uAC1C \uC774\uC0C1\uC758 \uC870\uAC74\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
        }
        if (handleSizeFilter) {
            handleSizeFilter(selectedSizes);
        } else {
            _$updateProductFilters({
                sizes: selectedSizes,
                code: router.query.code,
                hash: router.query.hash || productFilters.hash
            });
        }
    };
    var onChangeSize = function(id) {
        return function(e) {
            setSizes(_objectSpread({}, selectedSizes, _defineProperty({}, id, e.target.value)));
        };
    };
    var handleInput = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            setTimeout(function() {
                handleFilter();
            }, 200);
        }
    };
    var sizes = [
        0,
        10,
        20,
        30,
        40,
        50,
        60
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SizeFilterWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("horizontal"),
                        placeholder: "\uAC00\uB85Cmm",
                        value: selectedSizes.horizontal,
                        onKeyDown: handleInput
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("vertical"),
                        placeholder: "\uC138\uB85Cmm",
                        value: selectedSizes.vertical,
                        onKeyDown: handleInput
                    }),
                    filterType === "box" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("height"),
                        placeholder: "\uB192\uC774mm",
                        value: selectedSizes.height,
                        onKeyDown: handleInput
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeSelect, {
                        id: "sizeFilter",
                        name: "sizeFilter",
                        onChange: onChangeSize("range"),
                        value: selectedSizes.range,
                        children: sizes.map(function(el, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("option", {
                                value: el > 0 ? el : "",
                                children: [
                                    "\xb1 ",
                                    el
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "btn",
                        onClick: handleFilter,
                        children: "\uC0AC\uC774\uC988 \uAC80\uC0C9"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MobileSizeFilterWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("horizontal"),
                        placeholder: "\uAC00\uB85C",
                        value: selectedSizes.horizontal
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("vertical"),
                        placeholder: "\uC138\uB85C",
                        value: selectedSizes.vertical
                    }),
                    filterType === "box" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("height"),
                        placeholder: "\uB192\uC774",
                        value: selectedSizes.height
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeSelect, {
                        id: "sizeFilter",
                        name: "sizeFilter",
                        onChange: onChangeSize("range"),
                        value: selectedSizes.range,
                        children: sizes.map(function(el, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("option", {
                                value: el > 0 ? el : "",
                                children: [
                                    "\xb1 ",
                                    el
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: handleFilter,
                        children: "\uC0AC\uC774\uC988 \uAC80\uC0C9"
                    })
                ]
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        productFilters: state.productFilters
    };
};
var mapDidpatchToProps = {
    updateProductFilters: _redux_action_productFiltersAction__WEBPACK_IMPORTED_MODULE_6__/* .updateProductFilters */ .lG
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDidpatchToProps)(SizeFilter));


/***/ }),

/***/ 57416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64384);
/* harmony import */ var _api_baskets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18682);
/* harmony import */ var _common_splicePrice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8025);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(68866);
/* harmony import */ var _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43181);
/* harmony import */ var _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4557);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83173);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48106);
/* harmony import */ var _SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74971);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81628);
/* harmony import */ var _common_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11769);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

















var SingleProduct = function(param) {
    var product1 = param.product, basketsItems = param.basketsItems, cartItems = param.cartItems, basketsCount = param.basketsCount, _$addToCart = param.addToCart, addToWishlist = param.addToWishlist, _$openQuickView = param.openQuickView, _$increaseCnt = param.increaseCnt, _$showToastAlert = param.showToastAlert, _$insertBasketsAction = param.insertBasketsAction, _$fetchBasketsAction = param.fetchBasketsAction, dummyList = param.dummyList, addCart = param.addCart, inCart = param.inCart, index = param.index;
    var inBasket = inCart ? inCart(product1) : (basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
        return basketsItem.pcode === product1.pcode;
    })) || (cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
        return cartItem.pcode === product1.pcode;
    }));
    // orderType 이 'O' 이거나 없으면 일반 구매 가능 상품
    var isOrderTypeO = !product1.orderType || product1.orderType === "O";
    var handleCart = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장바구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewCount",
                            pcode: product1.pcode
                        };
                        _ctx.next = 3;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_11__/* .ViewCountProduct */ .Ir)(body);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToDetail() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Wrapper */ .im, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImgWrapper */ .Q5, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImgWrapper */ .Q5, {
                                onClick: moveToDetail,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    src: product1.main_image,
                                    alt: product1.pname || "\uC0C1\uD488 \uC774\uBBF8\uC9C0",
                                    layout: "fill",
                                    objectFit: "cover",
                                    sizes: "(max-width: 768px) 100vw, 33vw",
                                    priority: index === 0
                                })
                            })
                        }),
                        product1.sfnz_view === "Y" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .SfnzBadge */ .L4, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: "https://file.caretbio.com/caretbio/75378c147862e82d7a9ede3651163fdd.png",
                                alt: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C \uCE5C\uD658\uACBD \uBC30\uC9C0"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductContentWrapper */ .ZD, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductName */ .rZ, {
                                onClick: moveToDetail,
                                children: product1.pname
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductBottomWrapper */ .qW, {
                            children: [
                                isOrderTypeO && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceWrapper */ .vN, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceBox */ .bz, {
                                        children: [
                                            product1.salePer > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                        children: [
                                                            product1.salePer,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: product1.price && " ".concat((0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.price), "\uC6D0")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "d-flex",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h5", {
                                                    children: [
                                                        (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.discount_price),
                                                        "\uC6D0"
                                                    ]
                                                })
                                            }),
                                            Number(product1.quantity) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    fontSize: "14px"
                                                },
                                                children: [
                                                    "\uAC1C\uB2F9",
                                                    " ",
                                                    (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(Math.floor(Number(product1.discount_price) / Number(product1.quantity))),
                                                    "\uC6D0"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                product1.sold_out === "Y" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "\uD488\uC808"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: isOrderTypeO && (!inBasket ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "mobonCart",
                                        onClick: function() {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-add"
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        onClick: function() {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-check"
                                        })
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .StickerWrapper */ .Mo, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ViewBox */ .HA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)((0,_common_helper__WEBPACK_IMPORTED_MODULE_13__/* .calcProdPoint */ .tB)((Number(String(product1.discount_price).replace(/[^\d.-]/g, "")) || 0) * 1)),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Sticker */ .My, {
                                                children: "P"
                                            }),
                                            " \uC801\uB9BD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-view.png",
                                                alt: "\uC870\uD68C\uC218 \uC544\uC774\uCF58"
                                            }),
                                            product1.hit
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count
    };
};
var mapDispatchToProps = {
    addToCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__/* .addToCart */ .Xq,
    openQuickView: _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_15__/* .openQuickView */ .$,
    increaseCnt: _redux_action_cart__WEBPACK_IMPORTED_MODULE_14__/* .increaseCnt */ .us,
    showToastAlert: _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__/* .showToastAlert */ .I,
    insertBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .insertBasketsAction */ .el,
    fetchBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .fetchBasketsAction */ .Ei
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(SingleProduct));


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    width: fit-content;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    padding: 30px;\n    border-radius: 10px;\n\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n    @media (max-width: 575px) {\n      padding: 10px;\n      width: 90vw;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    & h5 {\n      font-size: 18px;\n      margin: 15px 0px;\n      & pre {\n        overflow: visible !important;\n        text-align: center;\n      }\n      @media (max-width: 575px) {\n        font-size: 1rem;\n      }\n    }\n    & img {\n      width: 75%;\n    }\n\n    & a {\n      margin-top: 20px;\n      width: 200px;\n    }\n\n    @media (max-width: 991px) {\n      & a {\n        width: 150px;\n      }\n    }\n    @media (max-width: 767px) {\n      & a {\n        width: 130px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-751e3b31-0"
})(_templateObject());
var InquiryCompleteModal = function(param) {
    var onClickInquiryComplete = param.onClickInquiryComplete, confirmText = param.confirmText, confirmImg = param.confirmImg;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiryComplete();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: confirmImg || "/assets/imgs/page/common/inquiry_complete_icon.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: confirmText || "\uC18C\uC911\uD55C \uC815\uBCF4 \uAC10\uC0AC\uD569\uB2C8\uB2E4!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn",
                            onClick: onClickInquiryComplete,
                            children: "\uC644\uB8CC"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InquiryCompleteModal);


/***/ }),

/***/ 7510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
// EXTERNAL MODULE: ./components/customizing/print/printTab/PrintTab.jsx
var PrintTab = __webpack_require__(48071);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/customizing/print/Print.styles.js
var Print_styles = __webpack_require__(32252);
// EXTERNAL MODULE: ./components/customizing/print/printCart/PrintCart.js + 1 modules
var PrintCart = __webpack_require__(34077);
// EXTERNAL MODULE: ./components/customizing/print/PrintDesignService.js
var PrintDesignService = __webpack_require__(52658);
// EXTERNAL MODULE: ./hook/app/useUserInfo.js
var useUserInfo = __webpack_require__(15259);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/filterList/FilterList.styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ececec;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid #ececec;\n  :last-of-type {\n    border: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 160px;\n  padding: 10px;\n  background-color: #3bb77e;\n  color: #fff;\n\n  .expand {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  & li {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    position: relative;\n    & a {\n      color: #121212;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      padding: 0px 10px;\n      :hover {\n        text-decoration: underline !important;\n      }\n    }\n    .active {\n      background-color: #3bb77e;\n      color: #fff;\n      border-radius: 10px;\n    }\n    & span {\n      display: none;\n      justify-content: center;\n      align-items: center;\n      border-radius: 100%;\n      position: absolute;\n      top: 0px;\n      right: 0px;\n      background-color: #fff;\n      box-shadow: 0px 1px 1px #12121259;\n      color: #253d4e;\n      height: 15px;\n      width: 15px;\n      font-size: 8px;\n      padding: 8px;\n      border: 1px solid #ececec;\n      margin: 0px;\n      & i {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n    :hover {\n      & span {\n        display: flex;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  .all {\n    min-width: 160px;\n    border-right: 1px solid #ececec;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    & a {\n      display: flex;\n      align-items: center;\n      padding: 10px;\n      cursor: pointer;\n\n      & i {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-left: 5px;\n      }\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        '\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n\n  & li {\n    display: flex;\n    align-items: center;\n\n    & a {\n      color: #3bb77e !important;\n      font-weight: 500;\n      position: relative;\n      padding: 5px 10px;\n\n      ::after {\n        margin: 0px 5px;\n        content: "X";\n      }\n    }\n  }\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 50px;\n  border-top: 2px solid #121212;\n  border-bottom: 2px solid #121212;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 10px 0px;\n  border-bottom: 1px solid #ececec;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  & span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 10px;\n    border: 1px solid #ececec;\n    cursor: pointer;\n  }\n\n  .selected {\n    background-color: #3bb77e;\n    color: white;\n    border: 1px solid #3bb77e;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 10px 0px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-column-gap: 10px;\n  grid-row-gap: 20px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  word-break: keep-all;\n  margin-top: 50px;\n  & h4 {\n    margin-bottom: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  color: #253d4e;\n  .header {\n    background-color: #f9f6f6ba;\n  }\n  & tr {\n    text-align: center;\n    :hover {\n      background-color: #f9f6f6ba;\n    }\n  }\n\n  & th {\n    padding: 5px;\n    font-size: 14px;\n    word-break: keep-all;\n  }\n\n  & td {\n    padding: 10px;\n  }\n\n  & a {\n    color: #253d4e;\n  }\n\n  .img {\n    width: 10%;\n    padding: 5px;\n    & a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .name {\n    width: 15%;\n    & a {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      white-space: pre-wrap;\n      text-overflow: ellipsis;\n      word-break: keep-all;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .price {\n    color: #dc3545;\n  }\n\n  .btnWrapper {\n    width: 15%;\n  }\n\n  @media (max-width: 991px) {\n    & td {\n      padding: 5px;\n    }\n    .name {\n    }\n    .golgi {\n      width: 7%;\n    }\n    .feature {\n      width: 15%;\n    }\n    .sizes {\n      width: 10%;\n    }\n    .onePrice {\n      width: 10%;\n    }\n    .quantity {\n      width: 10%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 767px) {\n    & th {\n      font-size: 12px;\n    }\n    & td {\n      font-size: 12px;\n    }\n    .img {\n      display: none;\n    }\n    .golgi {\n      width: 7%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 575px) {\n    & th {\n      font-size: 10px;\n    }\n    & td {\n      font-size: 10px;\n      padding: 5px;\n    }\n    .name {\n      width: 25%;\n    }\n    .sizes {\n      display: none;\n    }\n    .strength {\n      width: 10%;\n    }\n    .feature {\n      width: 10%;\n    }\n    .golgi {\n    }\n    .onePrice {\n    }\n    .quantity {\n    }\n    .price {\n    }\n  }\n  @media (max-width: 460px) {\n    .quantity {\n      display: none;\n    }\n    .onePrice {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}

var FilterListSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-0"
})(_templateObject());
// -------------------- filter ------------------------
var FilterWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-1"
})(_templateObject1());
var FilterRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-2"
})(_templateObject2());
var FilterRowTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-3"
})(_templateObject3());
var FilterRowList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-91adbd0c-4"
})(_templateObject4());
var FilteredListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-5"
})(_templateObject5());
var CheckedFilters = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-91adbd0c-6"
})(_templateObject6());
// -------------------- list ------------------------
var ListWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-7"
})(_templateObject7());
var ListSortWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-8"
})(_templateObject8());
var ListViewTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-9"
})(_templateObject9());
var ListViewSelectBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-10"
})(_templateObject10());
var ProductsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-11"
})(_templateObject11());
var ProductsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-12"
})(_templateObject12(), function(props) {
    return props.searchTerm ? "repeat(4, 1fr)" : "repeat(4, 1fr)";
});
var ProductsSignWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-13"
})(_templateObject13());
// table type list
var TableTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-14"
})(_templateObject14());
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-91adbd0c-15"
})(_templateObject15());

// EXTERNAL MODULE: ./components/ecommerce/Filter/SizeFilter.js
var SizeFilter = __webpack_require__(82763);
;// CONCATENATED MODULE: ./components/filterList/Filter.js





var Filter = function(props) {
    var ref2, ref1;
    var handleQuery = props.handleQuery, filters = props.filters, queries = props.queries, handleSizeFilter = props.handleSizeFilter;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: ((ref2 = Object.keys(filters)) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterWrapper, {
            children: [
                Object.keys(filters).map(function(filter, i) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                        children: ((ref = filters[filter].values) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowTitle, {
                                    children: filters[filter].name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowList, {
                                    children: filters[filter].values.map(function(row, rowIdx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                onClick: function() {
                                                    return handleQuery(filters[filter].type, row.value);
                                                },
                                                className: "".concat(queries[filters[filter].type] && queries[filters[filter].type].includes(row.value) && "active"),
                                                children: [
                                                    row.name,
                                                    queries[filters[filter].type] && queries[filters[filter].type].includes(row.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fi-rs-cross"
                                                        })
                                                    })
                                                ]
                                            })
                                        }, rowIdx);
                                    })
                                })
                            ]
                        })
                    }, i);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowTitle, {
                            children: "\uC0AC\uC774\uC988"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowList, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex p-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeFilter/* default */.Z, {
                                    handleSizeFilter: handleSizeFilter,
                                    selectedCategory: queries.category_code
                                })
                            })
                        })
                    ]
                }),
                queries && Object.values(queries).filter(function(el) {
                    return el != "";
                }).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilteredListWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "all",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                onClick: function() {
                                    sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
                                        x: window.scrollX,
                                        y: window.scrollY
                                    }));
                                    router.push("", {
                                        query: {}
                                    });
                                },
                                children: [
                                    "\uC804\uCCB4 \uD574\uC81C ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-rotate-left"
                                    }),
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedFilters, {
                            children: ((ref1 = Object.keys(queries)) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && Object.keys(queries).map(function(query) {
                                if (query !== "sizes") {
                                    var ref;
                                    return (ref = filters[query]) === null || ref === void 0 ? void 0 : ref.values.map(function(value, vIdx) {
                                        if (queries[query].split(" ").includes(value.value)) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                onClick: function() {
                                                    return handleQuery(query, value.value);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: value.name
                                                })
                                            }, vIdx);
                                        } else {
                                            return "";
                                        }
                                    });
                                } else {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        onClick: function() {
                                            return handleQuery(query, "");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "\uC0AC\uC774\uC988 \uD544\uD130"
                                        })
                                    });
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var filterList_Filter = (Filter);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
;// CONCATENATED MODULE: ./components/ecommerce/Pagination.js


function Pagination(param) {
    var currentPage = param.currentPage, getPaginationGroup = param.getPaginationGroup, pages = param.pages, setCurrentPage = param.setCurrentPage;
    // 현재페이지 State props필요
    var next = function() {
        setCurrentPage(function(page) {
            return page + 1;
        });
    };
    var prev = function() {
        setCurrentPage(function(page) {
            return page - 1;
        });
    };
    var handleActive = function(item) {
        setCurrentPage(item);
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("ul", {
            className: "pagination justify-content-start",
            children: [
                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ _jsx("li", {
                    onClick: prev,
                    className: "page-item",
                    children: currentPage === 1 ? null : /*#__PURE__*/ _jsx("a", {
                        className: "page-link",
                        children: /*#__PURE__*/ _jsx("i", {
                            className: "fi-rs-angle-double-small-left"
                        })
                    })
                }),
                getPaginationGroup.map(function(item, index) {
                    return /*#__PURE__*/ _jsx("li", {
                        onClick: function() {
                            return handleActive(item);
                        },
                        className: currentPage === item ? "page-item active" : "page-item",
                        children: /*#__PURE__*/ _jsx("a", {
                            className: "page-link",
                            children: item
                        })
                    }, index);
                }),
                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ _jsx("li", {
                    onClick: next,
                    className: "page-item",
                    children: currentPage >= pages ? null : /*#__PURE__*/ _jsx("a", {
                        className: "page-link",
                        children: /*#__PURE__*/ _jsx("i", {
                            className: "fi-rs-angle-double-small-right"
                        })
                    })
                }),
                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ _jsxs("li", {
                    className: "d-flex align-items-center ml-10",
                    children: [
                        currentPage,
                        " / ",
                        pages
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var ecommerce_Pagination = ((/* unused pure expression or super */ null && (Pagination)));

// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
// EXTERNAL MODULE: ./components/products/list/TableTypeList.js
var TableTypeList = __webpack_require__(17461);
;// CONCATENATED MODULE: ./components/filterList/FilteredList.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var FilteredList = function(props) {
    var viewType = props.viewType, handleListViewType = props.handleListViewType, dummyList = props.dummyList, filteredList = props.filteredList, addCart = props.addCart, inCart = props.inCart;
    var router = (0,next_router.useRouter)(), limit = 12, showPagination = 5;
    var ref = (0,react.useState)([]), pagination = ref[0], setPagination = ref[1];
    var ref1 = (0,react.useState)([]), paginatedList = ref1[0], setPaginatedList = ref1[1];
    var pages = filteredList && Math.ceil(filteredList.length / limit);
    // pagination
    var createPagination = function() {
        var arr = new Array(pages).fill().map(function(_, idx) {
            return idx + 1;
        });
        setPagination(arr);
    };
    var startIndex = (router.query.page ? Number(router.query.page) : 1) * limit - limit;
    var endIndex = startIndex + limit;
    var start = Math.floor(((router.query.page ? router.query.page : 1) - 1) / showPagination) * showPagination;
    var end = start + showPagination;
    var getPaginationGroup = pagination.slice(start, end);
    // 페이지 네이션
    var next = function() {
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        router.push({
            pathname: "",
            query: _objectSpread({}, router.query, {
                page: start + 6
            })
        });
    };
    var prev = function() {
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        router.push({
            pathname: "",
            query: _objectSpread({}, router.query, {
                page: start
            })
        });
    };
    var handleActive = function(page) {
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        router.push({
            pathname: "",
            query: _objectSpread({}, router.query, {
                page: page
            })
        });
    };
    (0,react.useEffect)(function() {
        if (filteredList) {
            createPagination();
            setPaginatedList(filteredList.slice(startIndex, endIndex));
        }
    }, [
        filteredList,
        router.query.page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWrapper, {
            style: {
                borderBottom: "none"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListSortWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListViewTypeWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "me-2",
                                    children: [
                                        "\uCD1D ",
                                        filteredList.length,
                                        "\uAC1C\uC758 \uC0C1\uD488"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListViewSelectBox, {
                                    listViewType: viewType ? viewType : "grid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: !viewType || viewType === "grid" ? "selected" : "",
                                            onClick: function() {
                                                return handleListViewType("grid");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-grid"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: viewType && viewType === "list" ? "selected" : "",
                                            onClick: function() {
                                                return handleListViewType("list");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-list"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsWrapper, {
                    children: [
                        (!viewType || viewType === "grid") && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid, {
                            children: paginatedList && paginatedList.map(function(item, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                                        product: item,
                                        dummyList: dummyList,
                                        addCart: addCart,
                                        inCart: inCart
                                    })
                                }, i);
                            })
                        }),
                        viewType && viewType === "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTypeList/* default */.Z, {
                                productList: paginatedList,
                                dummyList: dummyList,
                                addCart: addCart,
                                inCart: inCart,
                                viewFeature: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pagination-area mb-15",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": "Page navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "pagination justify-content-center",
                            children: [
                                start == 0 || getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: prev,
                                    className: "page-item",
                                    children: (router.query.page ? router.query.page : 1) == 1 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "page-link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-angle-double-small-left"
                                        })
                                    })
                                }),
                                getPaginationGroup.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        onClick: function() {
                                            return handleActive(item);
                                        },
                                        className: (router.query.page ? router.query.page : 1) == item ? "page-item active" : "page-item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "page-link",
                                            children: item
                                        })
                                    }, index);
                                }),
                                getPaginationGroup.length <= 0 || pages <= 5 || end > pages ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: next,
                                    className: "page-item",
                                    children: (router.query.page ? router.query.page : 1) >= pages ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "page-link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-angle-double-small-right"
                                        })
                                    })
                                }),
                                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "d-none d-md-flex align-items-center ml-10",
                                    children: [
                                        "\uCD1D ",
                                        pages,
                                        " \uD398\uC774\uC9C0"
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var filterList_FilteredList = (FilteredList);

;// CONCATENATED MODULE: ./components/filterList/FilterList.js
function FilterList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FilterList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FilterList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var FilterList = function(props) {
    var dummyList = props.dummyList, productList = props.productList, addCart = props.addCart, inCart = props.inCart;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(""), viewType = ref3[0], setViewType = ref3[1];
    var ref1 = (0,react.useState)([]), filteredList = ref1[0], setFilteredList = ref1[1];
    var ref2 = (0,react.useState)({}), filters = ref2[0], setFilters = ref2[1];
    var handleListViewType = function(type) {
        if (viewType === type) {
            return;
        }
        localStorage.setItem("P_viewType", type);
        setViewType(type);
    };
    var _query = router.query, page = _query.page, queries = _objectWithoutProperties(_query, [
        "page"
    ]);
    // 필터 라우팅
    var handleQuery = function(type, value) {
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        if (type === "sizes") {
            var sizes = queries.sizes, rest = _objectWithoutProperties(queries, [
                "sizes"
            ]);
            router.push({
                pathname: "",
                query: FilterList_objectSpread({}, rest)
            });
            return;
        }
        var prevQuery = queries[type];
        var query = "";
        if (prevQuery && prevQuery.split(" ").includes(value)) {
            // 이미 선택된 값이면 제거
            var tempArr = prevQuery.split(" ");
            var idx = tempArr.findIndex(function(el) {
                return el === value;
            });
            tempArr.splice(idx, 1);
            query = tempArr.join(" ");
        } else {
            // 새 값 추가 - 모든 타입에서 다중 선택 허용
            if (queries[type]) {
                query = "".concat(prevQuery, " ").concat(value);
            } else {
                query = value;
            }
        }
        if (!queries[type]) {
            router.push({
                pathname: "",
                query: FilterList_objectSpread({}, queries, FilterList_defineProperty({}, type, value))
            });
        } else {
            router.push({
                pathname: "",
                query: FilterList_objectSpread({}, queries, FilterList_defineProperty({}, type, query))
            });
        }
    };
    // 필터 만들기
    var getFilters = function() {
        var ref;
        // 1. 먼저 전체 제품에서 사용 가능한 카테고리 추출
        var productsCate = [];
        productList.forEach(function(el) {
            if (!productsCate.includes(el.category_code)) {
                productsCate.push(el.category_code);
            }
        });
        // 2. 카테고리 필터 생성
        var categories = dummyList === null || dummyList === void 0 ? void 0 : (ref = dummyList.category) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return productsCate.includes(el.code);
        });
        var categoryFilter = {
            type: "category_code",
            name: "\uCE74\uD14C\uACE0\uB9AC",
            values: categories ? categories.map(function(el) {
                return {
                    name: el.name,
                    value: el.code
                };
            }) : []
        };
        // 3. 선택된 카테고리에 따라 제품 필터링
        var filteredProducts = productList;
        // 선택된 카테고리가 있으면 해당 카테고리 상품만 필터링
        if (queries.category_code) {
            var selectedCategories = queries.category_code.split(" ");
            filteredProducts = productList.filter(function(product) {
                return selectedCategories.includes(product.category_code);
            });
        }
        // 4. 필터링된 제품에서 세부 카테고리와 주원료 추출
        var productsHash = [];
        var productsFeature = [];
        filteredProducts.forEach(function(el) {
            // 세부 카테고리 추출
            if (el.category_tag && !productsHash.includes(el.category_tag)) {
                productsHash.push(el.category_tag);
            }
            // 주원료 추출
            if (el.feature && el.feature !== "" && !productsFeature.includes(el.feature)) {
                productsFeature.push(el.feature);
            }
        });
        // 5. 세부 카테고리 필터 생성
        var categoryTagFilter = {
            type: "category_tag",
            name: "\uC138\uBD80 \uCE74\uD14C\uACE0\uB9AC",
            values: []
        };
        if (productsHash.length > 0) {
            var tempArr = [];
            productsHash.forEach(function(hashs) {
                hashs === null || hashs === void 0 ? void 0 : hashs.split(",").forEach(function(el) {
                    if (!tempArr.includes(el)) tempArr.push(el);
                });
            });
            categoryTagFilter.values = tempArr.map(function(el) {
                return {
                    name: el,
                    value: el
                };
            });
        }
        // 6. 주원료 필터 생성
        var featureFilter = {
            type: "feature",
            name: "\uC8FC\uC6D0\uB8CC",
            values: []
        };
        if (productsFeature.length > 0) {
            featureFilter.values = productsFeature.map(function(el) {
                return {
                    name: el,
                    value: el
                };
            });
        }
        // 7. 필터 상태 업데이트
        setFilters(FilterList_objectSpread({}, filters, {
            category_code: categoryFilter,
            category_tag: categoryTagFilter,
            feature: featureFilter
        }));
    };
    // queries로 필터 적용
    var filtering = function() {
        if (Object.keys(router.query) && Object.values(router.query).filter(function(el) {
            return el != "";
        }).length > 0) {
            var query = queries;
            var filterKeys = Object.keys(queries);
            var tempList = productList;
            filterKeys.forEach(function(key) {
                if (!query[key] || query[key] === "") return;
                tempList = tempList.filter(function(el) {
                    if (!query[key]) return true;
                    if (key === "sizes") {
                        var ref = JSON.parse(query.sizes), height = ref.height, horizontal = ref.horizontal, range = ref.range, vertical = ref.vertical;
                        if (horizontal > 0 && Number(horizontal) - Number(range) <= Number(el.horizontal) && Number(el.horizontal) <= Number(horizontal) + Number(range) || vertical > 0 && Number(vertical) - Number(range) <= Number(el.vertical) && Number(el.vertical) <= Number(vertical) + Number(range) || height > 0 && Number(height) - Number(range) <= Number(el.height) && Number(el.height) <= Number(height) + Number(range)) {
                            return true;
                        }
                        return false;
                    } else if (key === "category_code") {
                        // 카테고리 다중 선택 처리
                        var selectedCategories = query[key].split(" ");
                        return selectedCategories.includes(el[key]) || selectedCategories.length === 0;
                    } else if (key === "category_tag") {
                        // 세부 카테고리 다중 선택 처리
                        if (query[key] === "") return true;
                        var selectedTags = query[key].split(" ");
                        var productTags = el[key].split(",");
                        // 선택된 태그 중 하나라도 제품 태그에 포함되면 포함
                        return selectedTags.some(function(tag) {
                            return productTags.includes(tag);
                        }) || selectedTags.length === 0;
                    } else if (key === "feature") {
                        // 주원료 다중 선택 처리
                        if (query[key] === "") return true;
                        var selectedFeatures = query[key].split(" ");
                        return selectedFeatures.includes(el[key]) || selectedFeatures.length === 0;
                    } else {
                        // 기타 필터링
                        var selectedValues = query[key].split(" ");
                        return selectedValues.includes(el[key]) || selectedValues.length === 0;
                    }
                });
            });
            setFilteredList(tempList);
        } else {
            setFilteredList(productList);
        }
    };
    var handleSizeFilter = function(sizes) {
        var height = sizes.height, horizontal = sizes.horizontal, range = sizes.range, vertical = sizes.vertical;
        if (sizes) {
            sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
                x: window.scrollX,
                y: window.scrollY
            }));
            router.push({
                pathname: "",
                query: FilterList_objectSpread({}, queries, {
                    sizes: JSON.stringify(sizes)
                })
            });
        }
    };
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        if (localStorage.getItem("P_viewType")) {
            setViewType(localStorage.getItem("P_viewType"));
        } else {
            setViewType("list");
        }
        var routeChangeCompleteHandler = function() {
            // 페이지 이동 후 저장되어 있던 위치로 스크롤 복원
            var _scroll = sessionStorage.getItem("__next_scroll_".concat(router.pathname));
            if (_scroll) {
                // 스크롤 복원 후 저장된 위치 제거
                var ref = JSON.parse(_scroll), x = ref.x, y = ref.y;
                window.scrollTo(x, y);
                sessionStorage.removeItem("__next_scroll_".concat(router.pathname));
            }
        };
        router.events.on("routeChangeComplete", routeChangeCompleteHandler);
        return function() {
            router.events.off("routeChangeComplete", routeChangeCompleteHandler);
        };
    }, [
        router.isReady
    ]);
    (0,react.useEffect)(function() {
        if (!productList || !dummyList) return;
        getFilters();
        filtering();
    }, [
        productList,
        dummyList,
        router.query
    ]);
    // 페이지 진입 시 쿼리 초기화를 위한 코드 추가
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        var isPrintPage = router.pathname.includes("/print");
        var hasNoQuery = Object.keys(router.query).length === 0;
        // viewType 로컬스토리지 값 복원
        var savedViewType = localStorage.getItem("P_viewType");
        setViewType(savedViewType || "list");
        var routeChangeCompleteHandler = function() {
            var _scroll = sessionStorage.getItem("__next_scroll_".concat(router.pathname));
            if (_scroll) {
                var ref = JSON.parse(_scroll), x = ref.x, y = ref.y;
                window.scrollTo(x, y);
                sessionStorage.removeItem("__next_scroll_".concat(router.pathname));
            }
        };
        router.events.on("routeChangeComplete", routeChangeCompleteHandler);
        return function() {
            router.events.off("routeChangeComplete", routeChangeCompleteHandler);
        };
    }, [
        router.isReady
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterListSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(filterList_Filter, {
                    handleQuery: handleQuery,
                    filters: filters,
                    queries: queries,
                    handleSizeFilter: handleSizeFilter
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(filterList_FilteredList, {
                    viewType: viewType,
                    handleListViewType: handleListViewType,
                    dummyList: dummyList,
                    filteredList: filteredList,
                    addCart: addCart,
                    inCart: inCart
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ var filterList_FilterList = ((0,es/* connect */.$j)(mapStateToProps, null)(FilterList));

;// CONCATENATED MODULE: ./components/customizing/print/PrintInquiryModal.js
function PrintInquiryModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PrintInquiryModal_templateObject() {
    var data = PrintInquiryModal_taggedTemplateLiteral([
        '\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    position: fixed;\n    top: 10vh;\n    left: 25vw;\n    width: 50vw;\n    max-height: 80vh;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    @media screen and (max-width: 991px) {\n      top: 10vh;\n      left: 15vw;\n      width: 70vw;\n      max-height: 80vh;\n    }\n    @media screen and (max-width: 767px) {\n      left: 10vw;\n      width: 80vw;\n    }\n  }\n\n  .header {\n    display: flex;\n    padding: 10px 10px;\n    & img {\n      margin-left: auto;\n      width: 35px;\n      cursor: pointer;\n    }\n  }\n  .title {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 30px;\n    & h4 {\n      color: #3bb77e;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    padding: 0px 36px 36px 36px !important;\n    & > span {\n      color: black;\n    }\n  }\n\n  .inputWrapper {\n    width: 100%;\n    margin-bottom: 20px;\n    & h6 {\n      margin-bottom: 10px;\n      ::after {\n        content: "*";\n        margin-left: 2px;\n      }\n    }\n    & input {\n      height: 38px;\n      margin-bottom: 10px;\n      ::placeholder {\n        font-size: 14px;\n        color: #6c757da5;\n      }\n      :focus {\n        border-color: #3bb77e !important;\n        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n      }\n    }\n    .col {\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      & input {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n    @media screen and (max-width: 575px) {\n      .row {\n        display: flex;\n        flex-direction: column;\n        .col {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  & textarea {\n    min-height: 150px;\n    ::placeholder {\n      font-size: 14px;\n      color: #6c757da5;\n    }\n    :focus {\n      border-color: #3bb77e !important;\n      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n    }\n  }\n  .btnWrapper {\n    width: 100%;\n    & button {\n      width: 100%;\n    }\n  }\n\n  .checkboxWrapper {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-column-gap: 10px;\n    margin-bottom: 20px;\n    @media screen and (max-width: 767px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  .designCheck {\n    margin-bottom: 30px;\n    display: flex;\n    flex-wrap: wrap;\n  }\n'
    ]);
    PrintInquiryModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PrintInquiryModal_templateObject1() {
    var data = PrintInquiryModal_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: ",
        ";\n  word-break: keep-all;\n"
    ]);
    PrintInquiryModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PrintInquiryModal_templateObject2() {
    var data = PrintInquiryModal_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  font-size: 1rem;\n  padding: ",
        ";\n  overflow: hidden;\n  border: 2px solid #ececec;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
        ";\n  color: #4e4e4e;\n  border-color: ",
        ";\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n\n  & img {\n    margin: 0 auto;\n  }\n\n  .label_title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: #4e4e4e;\n    font-size: 14px;\n    text-align: center;\n\n    & i {\n      padding-top: 1px;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n"
    ]);
    PrintInquiryModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PrintInquiryModal_templateObject3() {
    var data = PrintInquiryModal_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 20px;\n  row-gap: 10px;\n  & input {\n    padding: 6px 5px;\n  }\n  @media screen and (max-width: 1200px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    PrintInquiryModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-0"
})(PrintInquiryModal_templateObject());
var CheckBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-1"
})(PrintInquiryModal_templateObject1(), function(props) {
    return props.design ? "5px" : "0";
});
var CheckBoxLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-699a6ec4-2"
})(PrintInquiryModal_templateObject2(), function(props) {
    return props.design ? "fit-content" : "100%";
}, function(props) {
    return props.design ? "10px 20px" : "10px 10px";
}, function(props) {
    return props.checked ? "#d6f2e5" : "#fff";
}, function(props) {
    return props.checked ? "#3bb77e" : "#ececec";
});
var FileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699a6ec4-3"
})(PrintInquiryModal_templateObject3());
var PrintInquiryModal = function(param) {
    var onClickInquiry = param.onClickInquiry, submitInquiry = param.submitInquiry, onChangeInquiry = param.onChangeInquiry, inquiryInputs = param.inquiryInputs;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiry();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/imgs/page/common/modal_close_icon.png",
                            alt: "modal_close_icon",
                            onClick: onClickInquiry
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "\uC815\uBCF4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inputWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uBB38\uC758\uC790(\uC5C5\uCCB4) \uBA85"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "name");
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uBB38\uC758\uC790 \uC5F0\uB77D\uCC98"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "tel");
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC774\uBA54\uC77C"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "email");
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC218\uB7C9"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: function(e) {
                                                            return onChangeInquiry(e, "cnt");
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uC778\uC1C4\uB97C \uC6D0\uD558\uB294 \uC0C1\uD488"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    onChange: function(e) {
                                                        return onChangeInquiry(e, "usages");
                                                    },
                                                    placeholder: "ex) EL606 \uD0DD\uBC30\uBD09\uD22C (\uC18C)"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uBB38\uC758 \uB0B4\uC6A9"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    type: "text",
                                                    onChange: function(e) {
                                                        return onChangeInquiry(e, "content");
                                                    },
                                                    placeholder: "ex) \uC5B8\uC81C\uAE4C\uC9C0 \uD544\uC694\uD558\uC2E0\uAC00\uC694, \uC5B4\uB5A4 \uB514\uC790\uC778\uC11C\uBE44\uC2A4\uAC00 \uD544\uC694\uD558\uC2E0\uAC00\uC694, \uCD94\uAC00\uC801\uC778 \uBB38\uC758\uC0AC\uD56D\uC744 \uB0A8\uACA8\uC8FC\uC138\uC694"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h6 text-dark",
                                                    children: "\uCCA8\uBD80 \uD30C\uC77C"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file1");
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file2");
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: function(e) {
                                                                return onChangeInquiry(e, "file3");
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row mb-20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "h6 text-dark",
                                                    children: "\uC720\uC758 \uC0AC\uD56D"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "border rounded p-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "1. \uBAA8\uB2C8\uD130\uC758 \uC0C9\uC0C1\uACFC \uCD5C\uC885 \uC778\uC1C4\uBB3C\uC758 \uC0C9\uC0C1\uC740 \uCC28\uC774\uAC00 \uC788\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "2. \uACE0\uC18D \uC778\uC1C4\uC640 \uC7AC\uB2E8 \uACFC\uC815\uC744 \uAC70\uCE58\uBBC0\uB85C \uC778\uC1C4 \uC704\uCE58 \uBC0F \uC0AC\uC774\uC988\uC758 \uC624\uCC28\uAC00 \uBC1C\uC0DD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "3. \uC5F4\uD48D\uC5D0 \uC758\uD55C \uAC74\uC870 \uBC29\uC2DD\uC73C\uB85C \uC789\uD06C\uAC00 \uC99D\uBC1C\uD558\uC5EC \uAE30\uD3EC\uAC00 \uC0DD\uAE30\uAC70\uB098 \uC0C9\uC0C1\uC774 \uBE60\uC9C0\uB294 \uACBD\uC6B0\uAC00 \uBC1C\uC0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "4. \uC778\uC1C4 \uBA74\uC801\uC774 \uB113\uC744 \uC2DC \uBE44\uC6A9\uC774 \uCD94\uAC00 \uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB610\uD55C \uC0C9\uC0C1 \uD45C\uD604\uC774 \uACE0\uB974\uC9C0 \uC54A\uAC70\uB098 \uBB3C\uACB0 \uBB34\uB2AC\uAC00 \uC0DD\uAE38 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "5. \uC704 \uC0AC\uC720\uB85C \uC778\uD55C \uC7AC\uC791\uC5C5\uC774\uB098 \uBC18\uD488\uC740 \uBD88\uAC00\uD569\uB2C8\uB2E4."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "6. \uC778\uC1C4 \uAD00\uB828\uB41C \uBB38\uC758\uB294 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uCC44\uB110\uD1A1\uC73C\uB85C \uC5B8\uC81C\uB4E0\uC9C0 \uB0A8\uACA8\uC8FC\uC138\uC694."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex flex-row justify-content-start align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "custome-checkbox",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                id: "checkBox1",
                                                                className: "form-check-input",
                                                                onChange: function(e) {
                                                                    return onChangeInquiry(e, "policy");
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "form-check-label",
                                                                htmlFor: "checkBox1",
                                                                style: {
                                                                    textTransform: "capitalize",
                                                                    color: "#696969",
                                                                    fontSize: "16px"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\uC720\uC758\uC0AC\uD56D\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4."
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "btnWrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn",
                                    onClick: submitInquiry,
                                    children: "\uBB38\uC758\uD558\uAE30"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var print_PrintInquiryModal = (PrintInquiryModal);

// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./hook/customizing/print/usePrintProductListQuery.js
var usePrintProductListQuery = __webpack_require__(44756);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
;// CONCATENATED MODULE: ./pages/customizing/print/product/index.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function product_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



















var ProductPage = function() {
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var listRef = (0,react.useRef)(null);
    var cartRef = (0,react.useRef)(null);
    var ref6 = (0,react.useState)({}), inquiryInputs = ref6[0], setInquiryInputs = ref6[1];
    var ref1 = (0,react.useState)(false), openInquiryModal = ref1[0], setOpenInquiryModal = ref1[1];
    var ref2 = (0,react.useState)(false), openInquiryComplete = ref2[0], setOpenInquiryComplete = ref2[1];
    var ref3 = (0,useUserInfo/* default */.Z)(), userInfo = ref3.userInfo, getUserInfo = ref3.getUserInfo;
    var ref4 = (0,usePrintProductListQuery/* usePrintProductListQuery */.u)(), productList = ref4.data;
    var ref5 = (0,usePrintProductListQuery/* usePrintCartItemsQuery */.J)(), tmp = ref5.data, printCartItems = tmp === void 0 ? [] : tmp;
    // 카트 담기
    var addPrintCart = function(product) {
        var ref;
        if (!(userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey)) {
            (0,common_alert/* failAlert */.qh)("\uB85C\uADF8\uC778 \uD6C4 \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4.");
            router.push("/login");
            return;
        }
        var currentCart = queryClient.getQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ]) || [];
        if (currentCart.find(function(el) {
            return el.pcode === product.pcode;
        })) {
            (0,common_alert/* failAlert */.qh)("\uC774\uBBF8 \uB2F4\uAE34 \uC0C1\uD488\uC785\uB2C8\uB2E4.");
            return;
        }
        var newCart = [
            product_objectSpread({}, product, {
                cnt: 1
            })
        ].concat(_toConsumableArray(currentCart));
        // 장바구니 업데이트
        queryClient.setQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ], newCart);
        sessionStorage.setItem("printCart", JSON.stringify(newCart));
        (0,common_alert/* successAlert */.Cq)("\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uACBC\uC2B5\uB2C8\uB2E4.");
    };
    // 카트 담긴 상태
    var inCart = function(product) {
        return printCartItems.some(function(el) {
            return el.pcode === product.pcode;
        });
    };
    var onClickInquiry = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setOpenInquiryModal(function(prev) {
                            return !prev;
                        });
                        setInquiryInputs({});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeInquiry = function(e, id) {
        if (id.includes("file")) {
            setInquiryInputs(product_objectSpread({}, inquiryInputs, product_defineProperty({}, id, e.target.files[0])));
            return;
        }
        if (id === "policy") {
            setInquiryInputs(product_objectSpread({}, inquiryInputs, product_defineProperty({}, id, e.target.checked)));
            return;
        }
        setInquiryInputs(product_objectSpread({}, inquiryInputs, product_defineProperty({}, id, e.target.value)));
    };
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    var submitInquiry = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!inquiryInputs.name || !inquiryInputs.tel || !inquiryInputs.cnt || !inquiryInputs.usages || !inquiryInputs.email || !inquiryInputs.content)) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uD56D\uBAA9\uC744 \uC804\uBD80 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        if (inquiryInputs.policy) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC720\uC758\uC0AC\uD56D\uC5D0 \uB3D9\uC758\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 6:
                        if (inquiryInputs.tel.match(/^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/)) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC0AC\uC6A9\uAC00\uB2A5\uD55C \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 9:
                        isLoading();
                        body = product_objectSpread({
                            modes: "InquirySet",
                            division: "F",
                            pcode: "P000001"
                        }, inquiryInputs);
                        _ctx.next = 13;
                        return (0,products/* inquirySet */.Bg)(body);
                    case 13:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uBB38\uC758\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            onClickInquiryComplete();
                            onClickInquiry();
                            setInquiryInputs({});
                            isLoaded();
                        } else {
                            (0,common_alert/* failAlert */.qh)("\uBB38\uC758 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                            isLoaded();
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getUserInfo();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                parent: "\uD648",
                sub: "\uC18C\uB7C9\uC778\uC1C4",
                subTitle: "\uC0C1\uD488\uC18C\uAC1C",
                pageTitle: SeoMeta/* SeoMeta.smallPrintServiceProduct.title */.e.smallPrintServiceProduct.title,
                pageDesc: SeoMeta/* SeoMeta.smallPrintServiceProduct.description */.e.smallPrintServiceProduct.description,
                pageKeyword: SeoMeta/* SeoMeta.smallPrintServiceProduct.keywords */.e.smallPrintServiceProduct.keywords,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintTab/* PrintTab */.d, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        ref: listRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* NormalTitle */.XG, {
                                children: [
                                    "\uC18C\uB7C9\uC778\uC1C4 ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "\uC0C1\uD488 \uC120\uD0DD"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(filterList_FilterList, {
                                productList: productList,
                                inCart: inCart,
                                addCart: addPrintCart
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintDesignService/* PrintDesignService */.$, {})
                ]
            }),
            openInquiryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(print_PrintInquiryModal, {
                onClickInquiry: onClickInquiry,
                inquiryInputs: inquiryInputs,
                onChangeInquiry: onChangeInquiry,
                submitInquiry: submitInquiry
            }),
            openInquiryComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryCompleteModal/* default */.Z, {
                onClickInquiryComplete: onClickInquiryComplete
            })
        ]
    });
};
/* harmony default export */ var product = (ProductPage);


/***/ }),

/***/ 43181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ openQuickView; },
/* harmony export */   "z": function() { return /* binding */ closeQuickView; }
/* harmony export */ });
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46330);

var openQuickView = function(product) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .OPEN_QUICK_VIEW */ .GS,
            payload: {
                product: product
            }
        });
    };
};
var closeQuickView = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE_QUICK_VIEW */ .fJ
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,2511,4027,9007,7461,928,9774,2888,179], function() { return __webpack_exec__(59968); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);